import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldCheck, ShieldOff } from "lucide-react";
import { API, authHeaders } from "./shared";

const SafeModeBanner = () => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/admin/safe-mode`, authHeaders())
      .then((r) => setState(r.data))
      .catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async () => {
    const turningOff = state.enabled;
    const msg = turningOff
      ? "Turn Ecommerce Safe Mode OFF? Client Blast and shop marketing emails will be able to send to your real subscriber list."
      : "Turn Ecommerce Safe Mode ON? Client Blast and shop marketing messages will be blocked. Salon booking messages are unaffected.";
    if (!window.confirm(msg)) return;
    setBusy(true);
    try {
      const r = await axios.put(`${API}/admin/safe-mode`, { enabled: !state.enabled }, authHeaders());
      toast.success(r.data.enabled ? "Ecommerce Safe Mode ON — shop marketing blocked" : "Ecommerce Safe Mode OFF — shop marketing live");
      load();
    } catch {
      toast.error("Failed to update Safe Mode");
    } finally { setBusy(false); }
  };

  if (!state) return null;

  return state.enabled ? (
    <div data-testid="safe-mode-banner" className="bg-amber-500/15 border-b border-amber-500/40">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex flex-wrap items-center gap-3">
        <ShieldCheck size={16} className="text-amber-400 shrink-0" />
        <p className="font-sans text-xs text-amber-300 flex-1">
          <span className="font-bold uppercase">Ecommerce Safe Mode ON</span> — Client Blast &amp; shop marketing messages are blocked for testing. Salon booking confirmations, reminders &amp; contact notifications are <span className="font-bold">LIVE as normal</span>.
          {state.suppressed_count > 0 && ` ${state.suppressed_count} blocked message${state.suppressed_count === 1 ? "" : "s"} logged.`}
        </p>
        <button data-testid="safe-mode-toggle-btn" onClick={toggle} disabled={busy} className="font-sans text-[11px] font-semibold px-3 py-1.5 border border-amber-400 text-amber-300 hover:bg-amber-400/10 transition-colors disabled:opacity-50">
          Turn Off (allow shop marketing)
        </button>
      </div>
    </div>
  ) : (
    <div data-testid="safe-mode-banner-off" className="bg-green-500/10 border-b border-green-500/30">
      <div className="max-w-7xl mx-auto px-6 py-1.5 flex items-center gap-3">
        <ShieldOff size={13} className="text-green-400 shrink-0" />
        <p className="font-sans text-[11px] text-green-400 flex-1">Ecommerce marketing live — Client Blast &amp; shop messages can send. Salon messaging unaffected.</p>
        <button data-testid="safe-mode-toggle-btn" onClick={toggle} disabled={busy} className="font-sans text-[11px] px-3 py-1 border border-green-500/40 text-green-400 hover:bg-green-500/10 transition-colors disabled:opacity-50">
          Turn Safe Mode On
        </button>
      </div>
    </div>
  );
};

export default SafeModeBanner;
